import React from 'react';
import BBIconConstructionCone from "../../../assets/bbCustomIcons/BBIconConstructionCone";
import {Tooltip} from "@material-ui/core";
import {useSelector} from "react-redux";
import {isCurrentUserMemberOf} from "../../../util/bbHelpers";


const ComingSoonIconSettings = ({props})=>{

    const authUser = useSelector(({auth}) => auth.authUser);
    // const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({breachrisk})=> breachrisk);
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isDisabled = !isAdmin

    return(
        <div>
            <Tooltip title={`Coming Soon`}>
                <span>
                    <BBIconConstructionCone style={{color: "gray"}}/>
                </span>
            </Tooltip>
        </div>
    )
}

export default ComingSoonIconSettings;